!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, i = {}, r = t.parcelRequire5f74;
  null == r && ((r = function(t) {
    if (t in e) return e[t].exports;
    if (t in i) {
      var r = i[t];
      delete i[t];
      var a = {
        id: t,
        exports: {}
      };
      return e[t] = a, r.call(a.exports, a, a.exports), a.exports;
    }
    var s = new Error("Cannot find module '" + t + "'");
    throw s.code = "MODULE_NOT_FOUND", s;
  }).register = function(t, e) {
    i[t] = e;
  }, t.parcelRequire5f74 = r), (0, r.register)("1nhZH", (function(t, e) {
    var i, r, a, s;
    i = t.exports, r = "default", a = function() {
      return o;
    }, Object.defineProperty(i, r, {
      get: a,
      set: s,
      enumerable: !0,
      configurable: !0
    });
    class o {
      static doChange({id: t, quantity: e, properties: i = {}}, r = !1) {
        return fetch(`${Shopify.routes.root || "/"}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: t,
            quantity: e,
            properties: {
              ...i
            }
          })
        }).then((t => {
          if (!t.ok) throw new Error("Cart change failed");
          return t.ok && r && this.update(!0), t;
        })).catch((t => t));
      }
      static doUpdate(t, e, i = !1) {
        const r = Array.isArray(t) ? t.reduce(((t, i) => ({
          ...t,
          [i]: e
        })), {}) : {
          id: e
        };
        return fetch(`${Shopify.routes.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: r
          })
        }).then((t => {
          if (!t.ok) throw new Error("Cart update failed");
          return t.ok && i && this.update(!0), t;
        })).catch((t => t));
      }
      static doAdd({id: t, quantity: e, properties: i = {}}, r = !1) {
        return fetch(`${Shopify.routes.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [ {
              id: t,
              quantity: e,
              properties: {
                ...i
              }
            } ]
          })
        }).then((t => {
          if (!t.ok) throw new Error("Cart add failed");
          return t.ok && r && this.update(!0), t;
        })).catch((t => t));
      }
      static getCart() {
        return fetch(`${Shopify.routes.root || "/"}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }).then((t => {
          if (!t.ok) throw new Error("Failed to fetch cart");
          return t;
        })).catch((t => t));
      }
      static update(t = !1, e = "cart-drawer", i = null) {
        try {
          e = e.replace("cart-drawer", document.querySelector("cart-drawer").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        (e = e.split(",")).push("header"), e = [ ...new Set(e) ];
        const r = !!t || this.cartDrawerOpen;
        fetch(`${location.pathname}?sections=${e.join(",")}`, {
          method: "GET"
        }).then((t => t.json())).then((t => {
          Object.entries(t).forEach((t => {
            const [e, a] = t, s = (new DOMParser).parseFromString(a, "text/html");
            i ??= [ `[id^="shopify-section-"][id$="${e}"]`, "header" ], i.push("header [data-cart-count]", "form [data-cart-count]"), 
            i.forEach((t => {
              document.querySelectorAll(t).forEach((e => {
                const i = s.querySelector(t);
                i && (e.innerHTML = r ? i.innerHTML.replace('id="Cart"', 'id="Cart" checked') : i.innerHTML);
              }));
            }));
          }));
        }));
      }
    }
  }));
  var a = r("1nhZH");
  class s extends HTMLElement {
    constructor() {
      if (super(), this.form = this.querySelector("[data-form]"), !this.form) return;
      this.submit = this.form.querySelector("[data-submit]"), this.idInput = this.form.querySelector("[data-id]"), 
      this.radios = this.form.querySelectorAll("[data-option-radio]"), this.radioLabels = this.querySelectorAll("[data-radio-label]"), 
      this.giftWrappingForm = this.querySelector("[data-gift-wrapping-form]"), this.to = this.querySelector("[data-gift-wrapping-to]"), 
      this.message = this.querySelector("[data-gift-wrapping-message]");
      const t = this.querySelector("[data-product-variants]");
      this.variants = t ? JSON.parse(t.textContent) : [];
    }
    connectedCallback() {
      this.form.addEventListener("submit", this.handleSubmit.bind(this)), this.radios.forEach((t => {
        t.addEventListener("change", this.handleVariantChange.bind(this));
      })), this.radioLabels.forEach((t => {
        t.addEventListener("click", (t => this.onRadioLabelClick(t)));
      }));
    }
    handleVariantChange() {
      const t = [], e = new Set;
      this.radios.forEach((t => {
        e.add(t.name);
      })), e.forEach((e => {
        const i = this.querySelector(`input[name="${e}"]:checked`);
        i && t.push(i.value);
      }));
      const i = this.variants.find((e => e.options.every(((e, i) => e === t[i]))));
      i ? (this.idInput.value = i.id, this.updateSubmitButton(i)) : (this.submit.disabled = !0, 
      this.submit.textContent = window.strings.selectOptions);
    }
    onRadioLabelClick(t) {
      const e = t.target.dataset.for, i = document.getElementById(e);
      if (!i) return;
      i.checked = !i.checked;
      const r = i.name, a = document.querySelectorAll(`input[name="${r}"]`);
      Array.from(a).some((t => t.checked)) ? this.giftWrappingForm.classList.remove("hidden") : this.giftWrappingForm.classList.add("hidden");
    }
    updateSubmitButton(t) {
      t.available ? (this.submit.disabled = !1, this.submit.textContent = window.strings.addToCart) : (this.submit.disabled = !0, 
      this.submit.textContent = window.strings.soldOut);
    }
    handleSubmit(t) {
      t.preventDefault();
      const e = this.idInput?.value, i = this.querySelector("[data-gift-wrapping-product]:checked")?.value || null;
      let r = {};
      i && (r = this.getGiftMessageProperties()), e ? (this.setSubmitLoadingState(), a.default.doAdd({
        id: e,
        quantity: 1,
        properties: r
      }, !0).then((t => {
        const e = 200 === t.status ? window.strings.added : window.strings.error;
        this.setSubmitTemptState(e);
      })).then((() => {
        i && this.addGiftWrapProduct(i, e);
      })).catch((() => {
        this.setSubmitTemptState(window.strings.error);
      }))) : console.error("No variant ID found");
    }
    addGiftWrapProduct(t, e) {
      a.default.doAdd({
        id: t,
        quantity: 1,
        properties: {
          _hidden: "true",
          related_product_id: e
        }
      }, !0);
    }
    setSubmitLoadingState() {
      this.submit.disabled = !0, this.submit.dataset.previousText = this.submit.innerHTML, 
      this.submit.innerHTML = window.strings.adding;
    }
    setSubmitTemptState(t) {
      this.submit.disabled = !1, this.submit.innerHTML = t, setTimeout((() => {
        this.submit.innerHTML = this.submit.dataset.previousText;
      }), 1e3);
    }
    getGiftMessageProperties() {
      const t = this.to.value, e = this.message.value;
      return {
        ...t && {
          to: t
        },
        ...e && {
          message: e
        },
        gift_wrapped: "true"
      };
    }
  }
  customElements.get("product-form") || customElements.define("product-form", s);
}();